export const HEADER_HEIGHT = 72;

export const PAGE_WIDTH = {
  DEFAULT: 880,
  WIDE: 1200,
};
